import React from 'react'
import List from './List'
import { useStaffingAgencyMsaById } from 'src/queries'

interface BodyProps {
  id: string
}

const Body: React.FC<BodyProps> = (props) => {
  const { id } = props
  const agency = useStaffingAgencyMsaById(id)
  return (
    <List agency={agency} />
  )
}

export default Body
